module.exports = __webpack_public_path__ + "img/departures-back-digital-small.aca89b8c.jpeg";